module.exports = __webpack_public_path__ + "static/media/s_v10_30.6e9085b3.mp3";